import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

const steps = [
  {
    num: "01",
    title: "Kunden finden",
    desc: "Identifiziere täglich Betriebe, die dringend eine neue Website brauchen — schnell, gezielt, ohne Aufwand.",
  },
  {
    num: "02",
    title: "Anrufen & überzeugen",
    desc: "Nutze das bewährte Kurs-Skript: 1–2 Minuten Gespräch, klare Botschaft, Einwände im Griff.",
  },
  {
    num: "03",
    title: "Website in unter 15 Min.",
    desc: "Ein einziger Prompt — eine fertige, professionelle Website. Schick die kostenlose Preview direkt an den Kunden.",
  },
  {
    num: "04",
    title: "Angebot, Abschluss & Zahlung",
    desc: "Deal abschließen, Website live schalten, Domain einrichten — und bis zu 3.000€ kassieren.",
  },
];

export default function SolutionSection() {
  return (
    <section
      className="py-32 md:py-40 px-6 bg-[#0A0A0A]"
      data-testid="solution-section"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease }}
          className="text-center mb-24"
        >
          <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">
            Die Methode
          </span>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#F5F5F7] mt-4 leading-tight tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "-0.02em" }}
          >
            Vier Schritte. Ein System.
          </h2>
        </motion.div>

        <div className="space-y-0">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease, delay: i * 0.08 }}
              whileHover={{ x: 8, transition: { duration: 0.3, ease } }}
              className="flex gap-8 sm:gap-12 py-10 border-b border-white/6 last:border-0 group"
              data-testid={`solution-step-${i}`}
            >
              {/* Number */}
              <div className="shrink-0 pt-1">
                <span
                  className="text-5xl sm:text-6xl font-black text-[#C9A84C]/20 group-hover:text-[#C9A84C]/40 transition-colors duration-300 leading-none"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {step.num}
                </span>
              </div>
              {/* Content */}
              <div className="pt-2">
                <h3
                  className="text-xl sm:text-2xl font-bold text-[#F5F5F7] mb-2 group-hover:text-[#C9A84C] transition-colors duration-300"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {step.title}
                </h3>
                <p className="text-[#86868b] text-base leading-relaxed">{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
